import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input, Switch,  Popconfirm, message} from 'antd';
import {useApi} from "../provider/ApiProvider";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function RoleDialog({open, data, onChange, onClose}){

    const {api} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        form.setFieldsValue(data);
    },[data])

    const handleOk = () => {

    };

    const handleCancel = () => {
        onClose()
    };

    const onFinish = (values) => {
        if(data === null){
            setLoading(true);
            api.post("/roleRouter/role/store",values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }else{
            setLoading(true);
            api.put("/roleRouter/role/update/" + data.id,values).then(resp => {
                onClose();
                onChange();
                setLoading(false);
            }).finally(() => {
                setLoading(false);
            })
        }

    };

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }



    return (
        <Modal
            title={(data === null || data === undefined) ? "Rol Ekle" : "Düzenle"}
            visible={open} okType={"submit"}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button  key="back" onClick={handleCancel}>
                    İptal
                </Button>,


                <Button  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Kaydet
                </Button>,
            ]}
        >
            <Form
                form={form}
                id="company-dialog-form"
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                initialValues={data}
            >
                <Form.Item
                    label="Rol Adı"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="Kod"
                    name="code"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>

    )
}
